// extracted by mini-css-extract-plugin
export default {"address":"app-organizations-OrganizationDetails-OrganizationDetails-module__cyqsKgQQzCivOROn2ngg"};